/* "¿Olvidaste algo?" del carrito Croque.
   Agrega el producto sin salir de la página: en el cajón vuelve a pintar el
   carrito con la respuesta de Shopify; en la página del carrito la recarga. */
(function () {
  if (window.croqueCartUpsellReady) return;
  window.croqueCartUpsellReady = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-croque-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const section = button.closest('.croque-cart-upsell');
    const error = section && section.querySelector('.croque-cart-upsell__error');
    const drawer = document.querySelector('cart-drawer');
    const inDrawer = Boolean(drawer && drawer.contains(button));

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (error) error.hidden = true;

    const body = { items: [{ id: Number(button.dataset.croqueUpsellAdd), quantity: 1 }] };
    if (inDrawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((item) => item.id);
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || state.message || 'No se pudo agregar');

      if (inDrawer && state.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(state);
      } else {
        window.location.reload();
      }
    } catch (err) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (error) {
        error.textContent = err.message;
        error.hidden = false;
      }
    }
  });
})();
